import React from 'react';
import { LockIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink px-4 pb-32 pt-10 text-center" data-id="element-158" data-mp="207t4gfx6vxoq">
      <p className="flex items-center justify-center gap-2 font-display text-base font-extrabold uppercase text-white" data-id="element-159" data-mp="209x9502wx0q2">
        <LockIcon className="h-4 w-4 text-cta" aria-hidden="true" data-id="element-160" data-mp="2a5797i9r2y17" />
        Secure checkout
      </p>
      <p className="mt-1 text-sm text-white/60" data-id="element-161" data-mp="1mfmnirm7pmo8">Digital Product · One-Time Payment · Immediate Access</p>
      <p className="mx-auto mt-6 max-w-3xl text-xs text-white/50" data-id="element-162" data-mp="1hhl3o4gypjbp">
        © 2026 Dr. Valeria Montes — Orthodontic Torque Control Blueprint™. All Rights Reserved.
      </p>
      <p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-white/40" data-id="element-163" data-mp="1rf91j39v76y3">
        Professional Educational Disclaimer: This material is intended for qualified dental professionals and
        educational purposes only. It does not replace comprehensive patient assessment, evidence-based clinical
        judgment, specialist training, or applicable professional standards.
      </p>
    </footer>;
}